export enum InventoryExceptionType {
  DuplicateSerials = 1,
  CartonsOnMultiplePallets = 2,
  PalletsOnMultipleLocations = 3,
  ItemCountMismatch = 4
}
export enum ContainerType{
  NotContainer = 0,
  SerialNo = 1,
  Lot = 2,
  Carton = 3,
  Pallet = 4
}